export default __webpack_public_path__ + "static/media/rmx-step.f5d7cbad.png";